import { MapPin, Phone, Mail, Clock, Store } from "lucide-react";
import { Reveal, MaskedLines } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";
import { CONTACT, DISTRIBUTOR } from "../data/site";

const Contact = () => (
  <>
    <section className="relative pt-32 sm:pt-40 pb-14 overflow-hidden" data-testid="contact-hero">
      <div className="absolute inset-0 blueprint-grid" />
      <div className="relative mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
        <Reveal y={16}>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Contact / Request a Quote</p>
        </Reveal>
        <MaskedLines
          delay={0.1}
          lines={["TELL US WHAT", { node: <span className="text-amber">YOU RUN.</span> }]}
          className="mt-4 font-display font-black uppercase leading-[0.9] tracking-tight text-[clamp(2.8rem,7.5vw,7rem)]"
        />
        <Reveal delay={0.45} y={16}>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-slate-300 leading-relaxed">
            Send your requirements and our team will come back with a personal quotation — sizes, volumes,
            delivery location. No online payment, ever.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 pb-24" data-testid="contact-section">
      <div className="grid gap-10 lg:grid-cols-[1fr_1.4fr] items-start">
        <Reveal className="border border-white/10 bg-panel/50 p-8 sm:p-10 order-2 lg:order-1">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight text-white">Direct lines</h2>
          <ul className="mt-8 space-y-7 text-sm">
            <li>
              <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-amber mb-3">
                <MapPin size={13} /> Factory & Office
              </p>
              <p className="text-slate-300 leading-relaxed">
                {CONTACT.company}<br />
                {CONTACT.addressLines[0]},<br />
                {CONTACT.addressLines[1]}
              </p>
              <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500 leading-relaxed">
                {CONTACT.note}
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-amber mb-3">
                <Phone size={13} /> Phone
              </p>
              <div className="space-y-1">
                {CONTACT.phones.map((p) => (
                  <a key={p} href={`tel:+91${p}`} className="block font-display text-2xl font-bold text-white hover:text-amber transition-colors" data-testid={`contact-phone-${p}`}>
                    +91 {p}
                  </a>
                ))}
              </div>
            </li>
            <li>
              <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-amber mb-3">
                <Mail size={13} /> Email
              </p>
              <a href={`mailto:${CONTACT.email}`} className="text-slate-300 hover:text-white transition-colors break-all" data-testid="contact-email">
                {CONTACT.email}
              </a>
            </li>
            <li className="border-t border-white/10 pt-6">
              <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-amber mb-3">
                <Store size={13} /> North Tripura Distributor
              </p>
              <p className="text-slate-300 leading-relaxed">
                {DISTRIBUTOR.name},<br />{DISTRIBUTOR.location}
              </p>
              <a href={`tel:+91${DISTRIBUTOR.phone}`} className="mt-2 inline-block text-slate-300 hover:text-white transition-colors" data-testid="contact-distributor-phone">
                +91 {DISTRIBUTOR.phone}
              </a>
              <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.15em] text-slate-500">
                GST: {DISTRIBUTOR.gst} · {DISTRIBUTOR.authorized}
              </p>
            </li>
            <li>
              <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-amber mb-3">
                <Clock size={13} /> Response
              </p>
              <p className="text-slate-300 leading-relaxed">
                Every enquiry is answered personally by our team — usually within one working day.
              </p>
            </li>
          </ul>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2">
          <EnquiryForm />
        </Reveal>
      </div>
    </section>
  </>
);

export default Contact;
